import React from 'react';
import PropTypes from 'prop-types';

const CategoryGroupButton = ({ isActive, url, label }) => {
    return (
        <p className={isActive && 'current-filter'}>
            <a href={url}>{label}</a>
        </p>
    );
};

CategoryGroupButton.propTypes = {
    isActive: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

CategoryGroupButton.displayName = 'CategoryGroupButton';

export default CategoryGroupButton;



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/CategoryGroupFilter/CategoryGroupButton.jsx